import React, { useState } from 'react';



const BenefitsSection = () => {
  const [activeTab, setActiveTab] = useState('flexibility');

  const scrollToApplication = () => {
    const element = document.getElementById('jetzt-bewerben');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const benefits = {
    flexibility: {
      title: 'Maximale Flexibilität',
      description: 'Arbeiten Sie von überall und bestimmen Sie Ihre Arbeitszeiten selbst',
      features: [
        { icon: 'Home', title: 'Home Office', description: 'Arbeiten Sie bequem von zu Hause aus' },
        { icon: 'Clock', title: 'Flexible Zeiten', description: 'Bestimmen Sie Ihre Arbeitszeiten selbst' },
        { icon: 'Calendar', title: 'Urlaubsplanung', description: 'Planen Sie Ihren Urlaub nach Ihren Wünschen' },
        { icon: 'Smartphone', title: 'Mobile Arbeit', description: 'Arbeiten Sie von jedem Ort der Welt' }
      ]
    },
    compensation: {
      title: 'Flexible Vergütungsmodelle',
      description: 'Wählen Sie zwischen Freelancer-Tätigkeit und Festanstellung - für jede Präferenz das passende Modell',
      features: [
        { icon: 'Users', title: 'Freelancer', description: 'Fixpreis pro Beratung' },
        { icon: 'Briefcase', title: 'Festanstellung', description: 'Attraktives Grundgehalt' },
        { icon: 'TrendingUp', title: 'Leistungsboni', description: 'Zusätzliche Prämien für herausragende Leistungen' },
        { icon: 'Gift', title: 'Zusatzleistungen', description: 'Fortbildungen, Boni und vieles mehr' }
      ]
    },
    development: {
      title: 'Berufliche Entwicklung',
      description: 'Kontinuierliche Weiterbildung und Karrieremöglichkeiten',
      features: [
        { icon: 'GraduationCap', title: 'Fortbildungen', description: 'Regelmäßige Weiterbildungsangebote' },
        { icon: 'Award', title: 'Zertifizierungen', description: 'Anerkannte Qualifikationen erwerben' },
        { icon: 'Users', title: 'Mentoring', description: 'Erfahrene Kollegen als Mentoren' },
        { icon: 'TrendingUp', title: 'Karrierepfade', description: 'Klare Entwicklungsmöglichkeiten' }
      ]
    }
  };

  const tabs = [
    { id: 'flexibility', label: 'Flexibilität' },
    { id: 'compensation', label: 'Vergütung' },
    { id: 'development', label: 'Entwicklung' }
  ];

  const iconMap = {
    Home: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
    Clock: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    Calendar: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    Smartphone: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    Users: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    Briefcase: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    TrendingUp: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
    Gift: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
      </svg>
    ),
    GraduationCap: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
      </svg>
    ),
    Award: () => (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="6" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
      </svg>
    )
  };

  const activeData = benefits?.[activeTab];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-800 mb-4">Ihre Vorteile bei AdvoCall</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Entdecken Sie, was AdvoCall zu einem außergewöhnlichen Arbeitsplatz für Rechtsanwälte macht
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-10">
          <div className="flex bg-slate-100 rounded-lg p-1 gap-1">
            {tabs?.map((tab) => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`px-6 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                  activeTab === tab?.id
                    ? 'bg-white text-slate-800 shadow-sm'
                    : 'text-slate-500 hover:text-slate-700'
                }`}
              >
                {tab?.label}
              </button>
            ))}
          </div>
        </div>

        {/* Active Tab Content */}
        <div className="mb-10">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-semibold text-slate-800 mb-2">{activeData?.title}</h3>
            <p className="text-slate-600">{activeData?.description}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {activeData?.features?.map((feature, index) => {
              const IconComponent = iconMap?.[feature?.icon];
              return (
                <div
                  key={index}
                  className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-slate-300 transition-colors"
                >
                  <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center text-white mb-4">
                    {IconComponent ? <IconComponent /> : null}
                  </div>
                  <h4 className="font-semibold text-slate-800 mb-2">{feature?.title}</h4>
                  <p className="text-sm text-slate-600">{feature?.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={scrollToApplication}
            className="inline-flex items-center px-8 py-3 bg-slate-800 text-white font-medium rounded-lg hover:bg-slate-700 transition-colors"
          >
            Jetzt bewerben
          </button>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
